/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/Demands/IDemandHandler" />
import { DemandType } from "./DemandType";

// Note: Demands are a run-time evaluated contract which varies by layout.
// Primitive components should not expose new varieties of demands to existing consumers, unless downstream support is verified.

/** This expresses our union of all standard demand handlers. It implies that all default implementations must support its member operations. Not the convergent end-solution. */
export interface IDemandHandler {
    registerDemand(demandType: DemandType): void;
}
